import i from "./_baseIsEqual.js";
import e from "./get.js";
import f from "./hasIn.js";
import n from "./_isKey.js";
import a from "./_isStrictComparable.js";
import p from "./_matchesStrictComparable.js";
import s from "./_toKey.js";
var u = 1, A = 2;
function y(r, o) {
  return n(r) && a(o) ? p(s(r), o) : function(m) {
    var t = e(m, r);
    return t === void 0 && t === o ? f(m, r) : i(o, t, u | A);
  };
}
export {
  y as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseMatchesProperty.js
// module id = 1484
// module chunks = 67